import { ENABLE_LCA_COMPANY_UI_REDESIGN } from "../config/constants";
import CompanyList from "../screens/company/companyList/CompanyList";
import CompanyListNew from "../screens/lcaCompany/companyList/CompanyListNew";
import { adminAccess, userAccess } from "./useRoleAccess";

const CompanyGrid = ENABLE_LCA_COMPANY_UI_REDESIGN ? <CompanyListNew /> : <CompanyList />;

export const CompanyRoutes = [
  {
    path: "/company",
    route: CompanyGrid,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  }
];
